import { render } from "./fieldTextarea.vue?vue&type=template&id=34907030"
import script from "./fieldTextarea.vue?vue&type=script&lang=js"
export * from "./fieldTextarea.vue?vue&type=script&lang=js"

import exportComponent from "/builds/oleksandr.makhovskyi/admin-template/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__